import createLucideIcon from '../createLucideIcon';

const ArrowDownLeft = createLucideIcon('ArrowDownLeft', [
  ['line', { x1: '17', x2: '7', y1: '7', y2: '17', key: '1x90xz' }],
  ['polyline', { points: '17 17 7 17 7 7', key: 'aq42rd' }],
]);

export default ArrowDownLeft;
